import { render, staticRenderFns } from "./harbors.vue?vue&type=template&id=65807929&"
import script from "./harbors.vue?vue&type=script&lang=js&"
export * from "./harbors.vue?vue&type=script&lang=js&"
import style0 from "./harbors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports